import { Component } from '@angular/core';

@Component({
    selector: 'app-no-admin-right',
    template: `<h2>No admin right</h2>
    <p>Requested page requires administrator rights</p>`
})
export class NoAdminRightComponent { }
